/**
 * Generates stock PDP URL from symbol
 * @param symbol - Stock symbol (e.g., "RELIANCE", "ICICI-BANK")
 * @returns Stock PDP URL (e.g., "/investments/reliance-share-price")
 */
export const getStockPdpUrl = (symbol: string): string => {
  if (!symbol) return '#';
  
  // Format symbol: replace & with -, convert to lowercase
  const formattedSymbol = symbol.replace(/&/g, '-').toLowerCase();
  return `/investments/${formattedSymbol}-share-price`;
};

